import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

const fmt = (n) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);

export default function Account() {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    if (user) api.get("/orders/mine").then((r) => setOrders(r.data.orders));
  }, [user]);

  if (loading) return <div className="pt-40 text-center overline">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div data-testid="account-page" className="pt-32 min-h-screen max-w-[1440px] mx-auto px-6 lg:px-12">
      <div className="overline">Trade Account</div>
      <h1 className="font-serif-editorial text-5xl lg:text-7xl mt-4 leading-none">{user.business_name || user.full_name || "Welcome."}</h1>
      <p className="mt-4 text-[#5C5C5C]">{user.email}</p>

      <div className="mt-16">
        <div className="overline mb-8">Order History</div>
        {orders.length === 0 ? (
          <p data-testid="no-orders" className="font-serif-editorial text-2xl italic text-[#5C5C5C]">No orders yet — your suite awaits.</p>
        ) : (
          <div className="space-y-6">
            {orders.map((o) => (
              <div key={o.id} data-testid={`order-${o.id}`} className="border border-[#E5E5E5] p-6 lg:p-8 grid md:grid-cols-4 gap-6 items-center">
                <div>
                  <div className="overline">Order</div>
                  <div className="font-mono text-xs mt-2 break-all">{o.id.slice(0, 8)}</div>
                </div>
                <div>
                  <div className="overline">Placed</div>
                  <div className="mt-2 text-sm">{new Date(o.created_at).toLocaleDateString()}</div>
                </div>
                <div>
                  <div className="overline">Status</div>
                  <div className="mt-2 text-sm capitalize">{o.payment_status}</div>
                </div>
                <div className="text-left md:text-right">
                  <div className="overline">Total</div>
                  <div className="font-serif-editorial text-2xl mt-2">{fmt(o.amount)}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
